/**
 * SOLID Review
 * S — Strong. One concern: a style sheet a view's markup needs, on the page once that view first shows.
 * O — Good. Any sheet; nothing here names one.
 * L — Strong. A view model (`IServiceViewModel`) with no state a view renders.
 * I — Strong. The view-model surface.
 * D — Strong. The platform's style sheets.
 */
import type { IServiceViewModel } from './IServiceViewModel';
import type { IServicePageStyles } from './platform/IConfigDepViewPlatform';

const NO_STATE: Readonly<Record<string, never>> = Object.freeze({});

/**
 * A VIEW'S STYLE SHEET (frontend-framework-oo P4, 2026-10-29, §28.296) — what a view's module did when it was imported (the 2D cup's
 * keyframes, `FallbackCupScene.tsx`): the sheet is added, by its id and once per page, when the view first shows, through the
 * platform (views touch no globals).
 */
export class PageStyleSheet implements IServiceViewModel<typeof NO_STATE> {
  constructor(
    private readonly styles: IServicePageStyles,
    private readonly id: string,
    private readonly css: string,
  ) {}

  getSnapshot(): typeof NO_STATE {
    return NO_STATE;
  }

  subscribe(): () => void {
    return () => undefined;
  }

  attach(): void {
    this.styles.ensure(this.id, this.css);
  }

  detach(): void {}
}
